import styled from '@emotion/styled/macro';

import FormMessage from '../../UI/Form/FormMessage/FormMessage';

export const StyledFormMessage = styled(FormMessage)`
  margin-top: 1.125rem;
`;
